export default "__VITE_ASSET__DAGgrBsg__"